"use client";

import Asterisk from "@/images/doodles/asterisk.png";
import { motion, useAnimationFrame, useMotionValue } from "framer-motion";
import { useLenis } from "lenis/react";
import { useRef } from "react";

const ScrollSpinSVG = () => {
  const rotate = useMotionValue(0);
  const directionRef = useRef(1);

  //Grab the shared Lenis instance & subscribe to scroll events
  //useLenis returns the Lenis instance and runs your callback on each scroll
  const lenis = useLenis(({ velocity }) => {
    if (Math.abs(velocity) > 0.01) {
      directionRef.current = velocity > 0 ? 1 : -1;
    }
  });

  //On each animation frame, read the current velocity and spin accordingly
  useAnimationFrame((t, delta) => {
    if (!lenis) return;
    const v = lenis.velocity;
    if (Math.abs(v) > 0.01) {
      const spinSpeed = 0.1;
      rotate.set(rotate.get() + directionRef.current * delta * spinSpeed);
    }
  });

  return (
    <div>
      <motion.img
        src={Asterisk.src}
        alt="asterisk"
        style={{ rotate }}
        className="mx-auto -mt-9 -ml-2 w-20"
      />
    </div>
  );
};

export default ScrollSpinSVG;
